/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The gender of the passenger
 * @export
 */
export const Gender = {
    Male: 'male',
    Female: 'female',
    Undisclosed: 'undisclosed',
    Unspecified: 'unspecified'
};
export function GenderFromJSON(json) {
    return GenderFromJSONTyped(json, false);
}
export function GenderFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function GenderToJSON(value) {
    return value;
}
